module.exports = __webpack_public_path__ + "media/images/icons/ic-home-e543d9c3d4acdc991933a419f2446851.svg";